<template>
  <VcSelectField :items="staff"
                 :pre-selection="initialSelection"
                 @selection-changed="onSelectionChanged" />
</template>

<script>
export default {
  name: 'AssignStaff',
  props: {
    initialSelection: {
      type: Object,
      required: true,
      validator: item => item.text && item.value,
    },
    staff: {
      type: Array,
      required: true,
      validator: staff => staff.every(item => item.text && item.value),
    },
  },
  methods: {
    onSelectionChanged(member) {
      this.$emit('onAssignStaff', member);
    },
  }
}
</script>
